import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapSettingsService } from '../services/MapSettingsService';

export function useTOS(
    initialState: boolean,
    remote: MapSettingsService
) {
    const getAccepted = () => initialState || window.localStorage.getItem('tos_accepted') === 'true';

    const [visible, setVisible] = useState(!getAccepted());
    const [accepted, setAccepted] = useState(getAccepted());
    const navigate = useNavigate();

    useEffect(() => {
        const isAccepted = initialState || window.localStorage.getItem('tos_accepted') === 'true';
        setAccepted(isAccepted);
        setVisible(!isAccepted);
    }, [initialState]);

    const onOkClick = () => {
        window.localStorage.setItem('tos_accepted', 'true');
        remote.updateUserWebSettings({ tos_accepted: true });
        setVisible(false);
        setAccepted(true);
    };

    const onNoClick = () => {
        navigate('/');
    };

    return {
        visible,
        accepted,
        onOkClick,
        onNoClick,
    };
}
